import { Address } from '../shared/models/Address';

export const devZones: Partial<Address>[] = [
  {
    CountryCode: 'POL',
  },
  {
    CountryCode: 'USA',
  },
];

export const prodZones: Partial<Address>[] = [
  {
    CountryCode: 'USA',
    Region: 'Alabama',
  },
  {
    CountryCode: 'USA',
    Region: 'Alaska',
  },
  {
    CountryCode: 'USA',
    Region: 'Arizona',
  },
  {
    CountryCode: 'USA',
    Region: 'Arkansas',
  },
  {
    CountryCode: 'USA',
    Region: 'California',
  },
  {
    CountryCode: 'USA',
    Region: 'Connecticut',
  },
  {
    CountryCode: 'USA',
    Region: 'District of Columbia',
  },
  {
    CountryCode: 'USA',
    Region: 'Florida',
  },
  {
    CountryCode: 'USA',
    Region: 'Georgia',
  },
  {
    CountryCode: 'USA',
    Region: 'Hawaii',
  },
  {
    CountryCode: 'USA',
    Region: 'Idaho',
  },
  {
    CountryCode: 'USA',
    Region: 'Illinois',
  },
  {
    CountryCode: 'USA',
    Region: 'Indiana',
  },
  {
    CountryCode: 'USA',
    Region: 'Iowa',
  },
  {
    CountryCode: 'USA',
    Region: 'Kansas',
  },
  {
    CountryCode: 'USA',
    Region: 'Kentucky',
  },
  {
    CountryCode: 'USA',
    Region: 'Louisiana',
  },
  {
    CountryCode: 'USA',
    Region: 'Maine',
  },
  {
    CountryCode: 'USA',
    Region: 'Maryland',
  },
  {
    CountryCode: 'USA',
    Region: 'Massachusetts',
  },
  {
    CountryCode: 'USA',
    Region: 'Michigan',
  },
  {
    CountryCode: 'USA',
    Region: 'Minnesota',
  },
  {
    CountryCode: 'USA',
    Region: 'Mississippi',
  },
  {
    CountryCode: 'USA',
    Region: 'Missouri',
  },
  {
    CountryCode: 'USA',
    Region: 'Montana',
  },
  {
    CountryCode: 'USA',
    Region: 'Nebraska',
  },
  {
    CountryCode: 'USA',
    Region: 'Nevada',
  },
  {
    CountryCode: 'USA',
    Region: 'New Hampshire',
  },
  {
    CountryCode: 'USA',
    Region: 'New Mexico',
  },
  {
    CountryCode: 'USA',
    Region: 'New York',
  },
  {
    CountryCode: 'USA',
    Region: 'North Carolina',
  },
  {
    CountryCode: 'USA',
    Region: 'North Dakota',
  },
  {
    CountryCode: 'USA',
    Region: 'Ohio',
  },
  {
    CountryCode: 'USA',
    Region: 'Oklahoma',
  },
  {
    CountryCode: 'USA',
    Region: 'Pennsylvania',
  },
  {
    CountryCode: 'USA',
    Region: 'Rhode Island',
  },
  {
    CountryCode: 'USA',
    Region: 'South Carolina',
  },
  {
    CountryCode: 'USA',
    Region: 'South Dakota',
  },
  {
    CountryCode: 'USA',
    Region: 'Tennessee',
  },
  {
    CountryCode: 'USA',
    Region: 'Texas',
  },
  {
    CountryCode: 'USA',
    Region: 'Utah',
  },
  {
    CountryCode: 'USA',
    Region: 'Vermont',
  },
  {
    CountryCode: 'USA',
    Region: 'Virginia',
  },
  {
    CountryCode: 'USA',
    Region: 'West Virginia',
  },
  {
    CountryCode: 'USA',
    Region: 'Wisconsin',
  },
  {
    CountryCode: 'USA',
    Region: 'Wyoming',
  },
];
